import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
// import logo from './Assets/laja-logo.png'

function Application() {

    const initialForm = {
        fullName: "",
        fatherHusbandName: "",
        mobileNumber: "",
        email: "",
        occupation: "",
        monthlyIncome: "",
        province: "",
        address:"",
        caseType: "",
        applicantCategory : "",
        caseSubject : "",
        caseDescription : "",
        declaration : false,
        cnic : "",
        captcha: "",
        captcha_token: ""
      };
    
    const [formData, setFormData] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [captchaImage, setCaptchaImage] = useState(" ");
    const [captchaToken, setCaptchaToken] = useState("");

    const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
        captcha_token: captchaToken,
      }));
    };
    // Clear form
    const handleClear = () => {
      setFormData(initialForm);
      setMessage("");
    };

     // Submit form using Axios POST
  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");

    // Basic validation
    if (
      !formData.fullName ||
      !formData.mobileNumber ||
      !formData.occupation ||
      !formData.monthlyIncome ||
      !formData.caseType ||
      !formData.caseSubject ||
      !formData.caseDescription ||
      !formData.province ||
      !formData.address ||
      !formData.cnic ||
      !formData.captcha
    ) {
      setMessage("Please fill all mandatory fields.");
      return;
    }

    if (!formData.declaration) {
      setMessage("Please agree to the declaration.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://laja.gov.pk/api/email_legal_aid.php",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      setMessage(
        response.data?.message || "Application submitted successfully."
      );

      if (response.data.success) {
        alert("Application submitted successfully.");
        setFormData(initialForm);
        getCaptcha();
      } else {
        alert(response.data.message || "Submission failed.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setMessage(
        error.response?.data?.message ||
          "Unable to submit application. Please try again."
      );
      alert(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };


    const getCaptcha = async () => {
        try {
            const response = await axios.get(
                "https://laja.gov.pk/api/captcha.php",
              {
                 withCredentials: true
              }
            );
            setCaptchaImage(response.data.captcha_image);
            setCaptchaToken(response.data.captcha_token);
        } catch (error) {
            console.error("CAPTCHA error:", error);
        }
    };

    useEffect(() => {
        getCaptcha();
    }, []);

  return (
    <><main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / Legal Aid Application Form</div>
      <h1>Apply for Free Legal Assistance</h1>
      <p>Please complete the form below to apply for free legal assistance. Our team will review your application and contact you within 3–5 working days regarding the status of your request.</p>
    </div>
  </div>
  <section className="section">
    <div className="container">
      <div className="form-layout">

        <div className="form-panel">
          <form onSubmit={handleSubmit}>

            <fieldset>
              <legend>Applicant Details</legend>

              <div className="form-row">
                <div className="form-field">
                  <label>Full Name<span className="req">*</span></label>
                  <input  type="text" name="fullName" value={formData.fullName} onChange={handleChange} required placeholder="As per cinc full name" />
                </div>
                <div className="form-field">
                  <label>Father / Husband Name</label>
                  <input  type="text" name="fatherHusbandName" value={formData.fatherHusbandName} onChange={handleChange} required placeholder="As per cinc father / husband name"/>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Mobile Number<span className="req">*</span></label>
                  <input  type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required placeholder="11-digit mobile number" maxLength="11" />
                </div>
                <div className="form-field">
                  <label>Email Address</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="xyz@gmail.com" />
                </div>
              </div>

               <div className="form-row">
                <div className="form-field">
                  <label>Occupation<span className="req">*</span></label>
                  <input type="text" name="occupation" value={formData.occupation} onChange={handleChange} required placeholder="Enter occupation" />
                </div>
                <div className="form-field">
                  <label>Monthly Income<span className="req">*</span></label>
                  <input type="number" name="monthlyIncome" value={formData.monthlyIncome} onChange={handleChange} required placeholder="Enter monthly income" min="0" />
                </div>
              </div>
               <div className="form-row">
                <div className="form-field">
                  <label>CNIC Number<span className="req">*</span></label>
                  <input type="number" name="cnic" value={formData.cnic} onChange={handleChange} min="0" required placeholder="13-digit cnic number" />
                </div>
                  <div className="form-field">
                  <label>Province</label>
                  <select name="province" value={formData.province} onChange={handleChange} required>
                    <option value="">Select Province</option>
                    <option value="Islamabad Capital">Islamabad Capital</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Khyber Pakhtunkhwa">Khyber Pakhtunkhwa</option>
                    <option value="Balochistan">Balochistan</option>
                    <option value="Sindh">Sindh</option>
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label>Postal Address<span className="req">*</span></label>
                <input type="text" name="address" value={formData.address} onChange={handleChange} rows="1" required placeholder="Enter your complete address including city district etc."/>
              </div>

             
            </fieldset>

            <fieldset>
              <legend>Case Details</legend>

              <div className="form-row">
                <div className="form-field">
                <label>Type of Case<span className="req">*</span></label>
                <select name="caseType" value={formData.caseType} onChange={handleChange} required>
                  <option value="">Select Case Type</option>
                  <option value="criminal">Criminal</option>
                  <option value="civil">Civil</option>
                  <option value="family">Family</option>
                  <option value="sexual_offense">Sexual Offense</option>
                  <option>Victim compensation grievance</option>
                  <option value="other">Other</option>
                </select>
                </div>
                <div className="form-field">
                  <label>Applicant Category</label>
                  <select name="applicantCategory" value={formData.applicantCategory} onChange={handleChange} required>
                    <option value="">Select category</option>
                    <option value="woman">Woman</option>
                    <option value="child">Child</option>
                    <option value="disabled">Person with Disability</option>
                    <option value="indigent">Indigent Person</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label>Case Subject<span className="req">*</span></label>
                <input type="text" name="caseSubject" value={formData.caseSubject} onChange={handleChange} required placeholder="Brief subject of the case" />
              </div>

              <div className="form-field">
                <label>Case Description<span className="req">*</span></label>
                <textarea name="caseDescription" value={formData.caseDescription} onChange={handleChange} required placeholder="Describe the issue, including relevant dates, names, and case or reference numbers" rows="6"></textarea>
                <span className="hint">Maximum 2,000 characters.</span>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Type Captcha Code<span className="req">*</span></label>
                  <input type="text" name="captcha" value={formData.captcha} onChange={handleChange} required placeholder="Enter Captcha Code" />
                </div>
                <div className="form-field">
                  <button className="captcha_refresh_btn" type="button" onClick={getCaptcha}>REFRESH CAPTCHA</button>
                  <img src={captchaImage} alt="CAPTCHA" height='40'/>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend>Declaration</legend>
              <div className="declaration">
                I declare that the information provided above is true and correct to the best of my knowledge, and I understand that furnishing false information may lead to rejection of this application.
              </div>
              <div className="checkbox-group">
                <label className="checkbox-option">
                  <input type="checkbox" name="declaration" checked={formData.declaration} onChange={handleChange}/>
                  <span>I agree to the declaration above and consent to being contacted regarding this application.<span className="req">*</span></span>
                </label>
              </div>
              
            </fieldset>

            <div className="form-actions">
              <button type="submit" disabled={loading} className="btn btn--gold">{loading ? "Submitting..." : "Submit Application"}</button>
              <button type="reset" onClick={handleClear} className="btn btn--outline-navy">Clear Form</button>
            </div>
            <p className="form-note">Fields marked <span className="req">*</span> are mandatory. On submission you will receive a reference number for tracking your application status.</p>
              {/* Message */}
              {message && (
                <div className="form-message">
                  {message}
                </div>
              )}
          </form>
        </div>

        <aside>
          <div className="receipt-card">
            {/* <img src={logo}  alt="Logo" width="50" height="50"/> */}
            <h3>Application Eligibility Criteria</h3>
            {/* <p>A reference number is generated automatically once your application is submitted.</p> */}
            <div className="receipt-line"><span>* Annual income below PKR 300,000</span></div>
            <div className="receipt-line"><span>* Unable to afford private legal counsel</span></div>
            <div className="receipt-line"><span>* Resident of the jurisdiction</span></div>
            <div className="receipt-line"><span>* Women and juvenile are on priority</span></div>

            {/* <div className="ref-box">REF NO. &mdash; ISSUED ON SUBMISSION</div> */}
          </div>

          <div className="helpline-box">
            <h4>Need help filling this form?</h4>
            <p>Call the helpline, available Monday&ndash;Friday, 9:00&ndash;17:00.</p>
            <p className="phone">051-9201790</p>
            <p style={{marginTop:'10px'}}>Or visit LAJA HQ 10th Floor, State life Building No.5, Blue Area, F6, Islamabad.</p>
          </div>
        </aside>

      </div>
    </div>
  </section>

</main></>
  );
}

export default Application;
